import React from 'react';
import { Route, Router, Switch, Redirect } from 'react-router';

import * as ROUTES from 'config/routes';

import {
	//Evacuation,
	EvacuationDemo,
	NotFound,
	Sitemap,
	MyAccount,
	Login,
	Directory,
	LiveView,
	FaceLiveView,
	SiteManager,
	Operators,
	Navigation,
	ClientRegistry,
	Attendance,
	ForgotPassword,
	ResetPassword,
	CancelPasswordReset,
	ChangePassword,
	Reports,
	Qlikdashboard,
	Qlikvisitorquery,
	Qlikcompanyquery,
	Qlikvisitorlist,
	Qlikmap,
	Qlikvisitanalysis,
	Qliksaascharges,
	QlikClarendondashboard,
	QlikClarendonvisitorlist,
	QlikClarendonvisitorquery,
	QlikClarendoncompanyquery,
	QlikClarendonmap,
	QlikClarendonvisitanalysis,
	QlikGrouchodashboard,
	QlikGrouchovisitorlist,
	QlikGrouchovisitorquery,
	QlikGrouchosaascharges,
	QlikGrouchomap,
	QlikGrouchovisitanalysis,
	QlikTsbdashboard,
	QlikTsbvisitorlist,
	QlikTsbvisitorquery,
	QlikTsbfunctionquery,
	QlikTsbmap,
	QlikTsbvisitanalysis,
	QlikTasudashboard,
	QlikTasucompanyquery,
	QlikTasuvisitorlist,
	QlikTasuvisitorquery,
	QlikTasusaascharges,
	QlikTasumap,
	QlikTasuvisitanalysis,
	Qlik25epcameracounting,
	Qlik25epdashboard,
	Qlik25epvisitorlist,
	Qlik25epvisitorquery,
	Qlik25epfunctionquery,
	Qlik25epmap,
	Qlik25epvisitanalysis,
	QlikTsbMagnoxdashboard,
	QlikTsbMagnoxvisitorlist,
	QlikTsbMagnoxvisitorquery,
	QlikTsbMagnoxmap,
	QlikTsbMagnoxvisitanalysis,
	QlikTsbGreshamdashboard,
	QlikTsbGreshamvisitorlist,
	QlikTsbGreshamvisitorquery,
	QlikTsbGreshamfunctionquery,
	QlikTsbGreshammap,
	QlikTsbGreshamvisitanalysis,
	QlikTsbKeypointdashboard,
	QlikTsbKeypointvisitorlist,
	QlikTsbKeypointvisitorquery,
	QlikTsbKeypointfunctionquery,
	QlikTsbKeypointmap,
	QlikTsbKeypointvisitanalysis,
	QlikGleneaglesdashboard,
	QlikGleneaglescompanyquery,
	QlikGleneaglesvisitorlist,
	QlikGleneaglesvisitorquery,
	QlikGleneaglesmap,
	QlikGleneaglesvisitanalysis,
	Notifications,
	Imports,
	Detectable,
	Summary,
	Client,
	ClientConfig,
	Site,
	Agent,
	Zone,
	Reader,
	Antenna,
	Camera,
	Profile,
	RealtimeView,
	FaceVisits,
	MfaSettings,
	LiveEvacuation,
} from '../pages';

export default ({ history }) => (
	<Router history={history}>
		<Switch>
			<Route exact path={ROUTES.LOGIN} component={Login} />
			<Route
				exact
				path={ROUTES.ACCEPT_INVITATION}
				component={ResetPassword}
			/>
			<Route
				exact
				path={ROUTES.FORGOT_PASSWORD}
				component={ForgotPassword}
			/>
			<Route
				exact
				path={ROUTES.CANCEL_PASSWORD_RESET}
				component={CancelPasswordReset}
			/>
			<Route
				exact
				path={ROUTES.RESET_PASSWORD}
				component={ResetPassword}
			/>
			<Route exact path={ROUTES.NOT_FOUND} component={NotFound} />

			<Route
				exact
				path={ROUTES.CHANGE_PASSWORD}
				component={ChangePassword}
			/>

			<Route exact path={ROUTES.SITEMAP} component={Sitemap} />
			<Route exact path={ROUTES.MY_ACCOUNT} component={MyAccount} />
			<Route exact path={ROUTES.NAVIGATION} component={Navigation} />

			<Route path={ROUTES.LIVE_VIEW} component={LiveView} />
			<Route path={ROUTES.LIVE_EVACUATION} component={LiveEvacuation} />
			<Route path={ROUTES.FACE_LIVE_VIEW} component={FaceLiveView} />
			<Route path={ROUTES.REALTIME_VIEW} component={RealtimeView} />
			<Route path={ROUTES.FACE_VISITS} component={FaceVisits} />
			<Route path={ROUTES.ATTENDANCE} component={Attendance} />
			<Route path={ROUTES.DIRECTORY} component={Directory} />
			<Route path={ROUTES.OPERATORS} component={Operators} />

			<Route path={ROUTES.CLIENT} component={Client} />
			<Route path={ROUTES.CLIENT_CONFIG} component={ClientConfig} />
			<Route path={ROUTES.SITE} component={Site} />
			<Route path={ROUTES.AGENT} component={Agent} />
			<Route path={ROUTES.ZONE} component={Zone} />
			<Route path={ROUTES.READER} component={Reader} />
			<Route path={ROUTES.ANTENNA} component={Antenna} />
			<Route path={ROUTES.CAMERA} component={Camera} />
			<Route path={ROUTES.PROFILE} component={Profile} />
			<Route path={ROUTES.DETECTABLE} component={Detectable} />
			<Route path={ROUTES.SUMMARY} component={Summary} />

			<Route path={ROUTES.SITE_MANAGER} component={SiteManager} />
			{/*<Route path={ROUTES.EVACUATION} component={Evacuation} /> OLD VER*/}
			<Route path={ROUTES.EVACUATION_DEMO} component={EvacuationDemo} />

			<Route path={ROUTES.CLIENT_REGISTRY} component={ClientRegistry} />

			<Route path={ROUTES.REPORTS} component={Reports} />

			<Route path={ROUTES.QLIKDASHBOARD} component={Qlikdashboard} />
			<Route
				path={ROUTES.QLIKVISITORQUERY}
				component={Qlikvisitorquery}
			/>
			<Route
				path={ROUTES.QLIKCOMPANYQUERY}
				component={Qlikcompanyquery}
			/>
			<Route path={ROUTES.QLIKVISITORLIST} component={Qlikvisitorlist} />
			<Route path={ROUTES.QLIKMAP} component={Qlikmap} />
			<Route
				path={ROUTES.QLIKVISITANALYSIS}
				component={Qlikvisitanalysis}
			/>
			<Route path={ROUTES.QLIKSAASCHARGES} component={Qliksaascharges} />
			<Route
				path={ROUTES.QLIKCLARENDONDASHBOARD}
				component={QlikClarendondashboard}
			/>
			<Route
				path={ROUTES.QLIKCLARENDONVISITORQUERY}
				component={QlikClarendonvisitorquery}
			/>
			<Route
				path={ROUTES.QLIKCLARENDONVISITORLIST}
				component={QlikClarendonvisitorlist}
			/>
			<Route
				path={ROUTES.QLIKCLARENDONCOMPANYQUERY}
				component={QlikClarendoncompanyquery}
			/>
			<Route
				path={ROUTES.QLIKCLARENDONMAP}
				component={QlikClarendonmap}
			/>
			<Route
				path={ROUTES.QLIKCLARENDONVISITANALYSIS}
				component={QlikClarendonvisitanalysis}
			/>
			<Route
				path={ROUTES.QLIKGROUCHODASHBOARD}
				component={QlikGrouchodashboard}
			/>
			<Route
				path={ROUTES.QLIKGROUCHOVISITORQUERY}
				component={QlikGrouchovisitorquery}
			/>
			<Route
				path={ROUTES.QLIKGROUCHOVISITORLIST}
				component={QlikGrouchovisitorlist}
			/>
			<Route
				path={ROUTES.QLIKGROUCHOCOMPANYQUERY}
				component={QlikGrouchosaascharges}
			/>
			<Route path={ROUTES.QLIKGROUCHOMAP} component={QlikGrouchomap} />
			<Route
				path={ROUTES.QLIKGROUCHOVISITANALYSIS}
				component={QlikGrouchovisitanalysis}
			/>

			<Route
				path={ROUTES.QLIKTSBDASHBOARD}
				component={QlikTsbdashboard}
			/>
			<Route
				path={ROUTES.QLIKTSBVISITORQUERY}
				component={QlikTsbvisitorquery}
			/>
			<Route
				path={ROUTES.QLIKTSBVISITORLIST}
				component={QlikTsbvisitorlist}
			/>
			<Route
				path={ROUTES.QLIKTSBFUNCTIONQUERY}
				component={QlikTsbfunctionquery}
			/>
			<Route path={ROUTES.QLIKTSBMAP} component={QlikTsbmap} />
			<Route
				path={ROUTES.QLIKTSBVISITANALYSIS}
				component={QlikTsbvisitanalysis}
			/>

			<Route
				path={ROUTES.QLIKTSBMAGNOXDASHBOARD}
				component={QlikTsbMagnoxdashboard}
			/>
			<Route
				path={ROUTES.QLIKTSBMAGNOXVISITORQUERY}
				component={QlikTsbMagnoxvisitorquery}
			/>
			<Route
				path={ROUTES.QLIKTSBMAGNOXVISITORLIST}
				component={QlikTsbMagnoxvisitorlist}
			/>
			<Route
				path={ROUTES.QLIKTSBMAGNOXMAP}
				component={QlikTsbMagnoxmap}
			/>
			<Route
				path={ROUTES.QLIKTSBMAGNOXVISITANALYSIS}
				component={QlikTsbMagnoxvisitanalysis}
			/>
			<Route
				path={ROUTES.QLIKTSBGRESHAMDASHBOARD}
				component={QlikTsbGreshamdashboard}
			/>
			<Route
				path={ROUTES.QLIKTSBGRESHAMVISITORQUERY}
				component={QlikTsbGreshamvisitorquery}
			/>
			<Route
				path={ROUTES.QLIKTSBGRESHAMVISITORLIST}
				component={QlikTsbGreshamvisitorlist}
			/>
			<Route
				path={ROUTES.QLIKTSBGRESHAMFUNCTIONQUERY}
				component={QlikTsbGreshamfunctionquery}
			/>
			<Route
				path={ROUTES.QLIKTSBGRESHAMMAP}
				component={QlikTsbGreshammap}
			/>
			<Route
				path={ROUTES.QLIKTSBGRESHAMVISITANALYSIS}
				component={QlikTsbGreshamvisitanalysis}
			/>
			<Route
				path={ROUTES.QLIKTSBKEYPOINTDASHBOARD}
				component={QlikTsbKeypointdashboard}
			/>
			<Route
				path={ROUTES.QLIKTSBKEYPOINTVISITORQUERY}
				component={QlikTsbKeypointvisitorquery}
			/>
			<Route
				path={ROUTES.QLIKTSBKEYPOINTVISITORLIST}
				component={QlikTsbKeypointvisitorlist}
			/>
			<Route
				path={ROUTES.QLIKTSBKEYPOINTFUNCTIONQUERY}
				component={QlikTsbKeypointfunctionquery}
			/>
			<Route
				path={ROUTES.QLIKTSBKEYPOINTMAP}
				component={QlikTsbKeypointmap}
			/>
			<Route
				path={ROUTES.QLIKTSBKEYPOINTVISITANALYSIS}
				component={QlikTsbKeypointvisitanalysis}
			/>

			<Route
				path={ROUTES.QLIKTASUDASHBOARD}
				component={QlikTasudashboard}
			/>
			<Route
				path={ROUTES.QLIKTASUCOMPANYQUERY}
				component={QlikTasucompanyquery}
			/>
			<Route
				path={ROUTES.QLIKTASUVISITORQUERY}
				component={QlikTasuvisitorquery}
			/>
			<Route
				path={ROUTES.QLIKTASUVISITORLIST}
				component={QlikTasuvisitorlist}
			/>
			<Route
				path={ROUTES.QLIKTASUSAASCHARGES}
				component={QlikTasusaascharges}
			/>
			<Route path={ROUTES.QLIKTASUMAP} component={QlikTasumap} />
			<Route
				path={ROUTES.QLIKTASUVISITANALYSIS}
				component={QlikTasuvisitanalysis}
			/>

			<Route
				path={ROUTES.QLIKGLENEAGLESDASHBOARD}
				component={QlikGleneaglesdashboard}
			/>
			<Route
				path={ROUTES.QLIKGLENEAGLESCOMPANYQUERY}
				component={QlikGleneaglescompanyquery}
			/>
			<Route
				path={ROUTES.QLIKGLENEAGLESVISITORQUERY}
				component={QlikGleneaglesvisitorquery}
			/>
			<Route
				path={ROUTES.QLIKGLENEAGLESVISITORLIST}
				component={QlikGleneaglesvisitorlist}
			/>
			<Route
				path={ROUTES.QLIKGLENEAGLESMAP}
				component={QlikGleneaglesmap}
			/>
			<Route
				path={ROUTES.QLIKGLENEAGLESVISITANALYSIS}
				component={QlikGleneaglesvisitanalysis}
			/>

			<Route
				path={ROUTES.QLIK25EPCAMERACOUNTING}
				component={Qlik25epcameracounting}
			/>
			<Route
				path={ROUTES.QLIK25EPDASHBOARD}
				component={Qlik25epdashboard}
			/>
			<Route
				path={ROUTES.QLIK25EPVISITORQUERY}
				component={Qlik25epvisitorquery}
			/>
			<Route
				path={ROUTES.QLIK25EPVISITORLIST}
				component={Qlik25epvisitorlist}
			/>
			<Route
				path={ROUTES.QLIK25EPFUNCTIONQUERY}
				component={Qlik25epfunctionquery}
			/>
			<Route path={ROUTES.QLIK25EPMAP} component={Qlik25epmap} />
			<Route
				path={ROUTES.QLIK25EPVISITANALYSIS}
				component={Qlik25epvisitanalysis}
			/>

			<Route path={ROUTES.NOTIFICATIONS} component={Notifications} />

			<Route path={ROUTES.IMPORTS} component={Imports} />

			<Route exact path={ROUTES.MFA_SETTINGS} component={MfaSettings} />

			<Redirect exact from="/" to={ROUTES.LIVE_VIEW} />
			<Redirect to={ROUTES.NOT_FOUND} component={NotFound} />
		</Switch>
	</Router>
);



// WEBPACK FOOTER //
// ./src/main/routes.js